import { container } from "tsyringe";
export class UseCaseGetCategories {
    async getCategories() {
        const _categories = container.resolve("iGetCategories");
        const result = await _categories.getCategories();
        return result;
    }
}
